/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var waitForJQuery = setInterval(function () {
	if (typeof $ != 'undefined') {
		console.log('loaded jquery')
		// place your code here.
		clearInterval(waitForJQuery);
		initApp();
	} else {
		console.log('waiting for jquery')
	}
}, 500);

// LOAD CAROUSEL IMAGES ONLY AFTER STOPPED SCROLLING
// jQuery: Lazy-load alternate product images on scroll-stop within the specific carousel in view
// (function($) {
//   // Delay (ms) to consider scroll "stopped"
//   var scrollStopDelay = 200;
//   var scrollTimer;

//   // Helper: check if an element is in the viewport
//   function isInViewport($el) {
//     var win = $(window);
//     var winTop = win.scrollTop();
//     var winBottom = winTop + win.height();
//     var elTop = $el.offset().top;
//     var elBottom = elTop + $el.outerHeight();
//     return elBottom > winTop && elTop < winBottom;
//   }

//   // Called when scroll stops
//   function onScrollStopped() {
//     console.log('scroll stopped');
//     var $all = $('.Swipe__Mobile__CollectionCarousel');
//     // Filter to only those in view
//     var $visible = $all.filter(function() {
//       return isInViewport($(this));
//     });
//     if (!$visible.length) return;

//     // Determine which visible container is closest to viewport center
//     var win = $(window);
//     var winMid = win.scrollTop() + win.height() / 2;
//     var $closest = null;
//     var minDist = Infinity;

//     $visible.each(function() {
//       var $cont = $(this);
//       var contMid = $cont.offset().top + $cont.outerHeight() / 2;
//       var dist = Math.abs(winMid - contMid);
//       if (dist < minDist) {
//         minDist = dist;
//         $closest = $cont;
//       }
      
//     });

//     if ($closest) {
//       // Trigger custom event with the container as context
//       $closest.trigger('scrollStoppedOn');

//       // Lazy-load its alternate images
//       $closest.find('.js-ProductItem__Image--alternate').each(function() {
//         var $img = $(this).find('img');
//         // console.log($img.attr('data-src-2'));
//         var dataSrc = $img.attr('data-src-2');
//         if (dataSrc) {
//           console.log(dataSrc);
//           $img.attr('src', dataSrc);
//         }
//       });
//     }
//   }

//   // Bind scroll with debounce
//   $(window).on('scroll', function() {
//     console.log('scrolled');
//     clearTimeout(scrollTimer);
//     scrollTimer = setTimeout(onScrollStopped, scrollStopDelay);
//   });

//   // Initial check on load
//   $(onScrollStopped);
// })(jQuery);
// END CAROUSEL IMAGES ONLY AFTER STOPPED SCROLLING

function initApp() {
	
	$.fn.isInViewport = function() {
		if ($(this).length) {
			var elementTop = $(this).offset().top;
			var elementBottom = elementTop + $(this).outerHeight();
			
			var viewportTop = $(window).scrollTop();
			var viewportBottom = viewportTop + $(window).height();
			
			return elementBottom > viewportTop && elementTop < viewportBottom;
		}
	};
	
	function initLazyCollectionImages() {
		var windowWidth = $(window).width();
		
		$('.ProductItem__Image--alternate').find('img').each(function () {
			var $this = $(this),
					imgSrc = $(this).data('flickity-lazyload');
			
			if (windowWidth > 900) {
				$this.attr('src', imgSrc);
			} else {
				var newSrc = imgSrc.replace('_1000x', '_300x');
				$this.attr('data-flickity-lazyload', newSrc)
			}
		});
	}
	
	function initCollectionCarousels() {
		var itemIds = [];
		$('.ProductItem').each(function(){
			var $id = $(this).attr('id');
			itemIds.push($id);
		});
		
		$(window).on('scroll', function() {
			$.each(itemIds, function( index, value ) {
				if ($('#' + value).isInViewport()) {
					var $product = $('#' + value);
					$product.find('.Image--lazyLoading').each(function(index){
						var $this = $(this),
                            newSrc = $this.data('flickity-lazyload');
						
						$this.attr('src', newSrc);
						$this.addClass('flickity-lazyloaded')
					})
				}
			});
		});
	}
	
	function initLazyCollectionProducts() {
		// Add second collection as a loading one
		$('.js-collection-section').each(function(index){
			var isLoading = $(this).hasClass('is-loading');
			console.log(index);
			if (isLoading) {
				if (index === 1) {
					$(this).parent().addClass('is-loading-section')
				} else {
					$(this).parent().addClass('is-hidden-section')
				}
			}
		})
	}
	
	function initLazyScrollProducts() {
        var windowWidth = $(window).width(),
            isVideosLoaded = false,
            initialProductsAmount = 2;
            
        // Load second images initially only for first X products
        if (windowWidth > 1000) {
          for (let i = 1; i <= initialProductsAmount; i++) {
            $('.js-ProductItem__ImageWrapper[data-product-count="' + i + '"]').not(".js-Image--Lazyload").each(function() {
              // Find the img and update its src
              var $imgWrapper = $(this).find('.js-ProductItem__Image--alternate');
              var $img = $imgWrapper.find('img');
              var originalSrc = $img.attr('data-original-src');
              if (originalSrc) {
                $img.attr('src', originalSrc);
                console.log(originalSrc);
                $imgWrapper.addClass('is-loaded')
                $imgWrapper.parents('.Swipe__Mobile__CollectionCarousel').addClass('.is-image-loaded')
                console.log('loaded');
              }
            });
          }

        }

        if (windowWidth > 1000) {
          $('.js-ProductItem__Image--alternate').each(function(){
            var $img = $(this).find('img'),
                newSrc = $img.attr('data-src-2');
                
            $img.attr('src', newSrc)
          })
        }
          
          

        // Load first banner initially
        const $elements1 = $('.js-PageHeader--Image');
        const $banners1 = $('.js-PageHeader--withBackground');

      
       $elements1.each(function (index) {
         if (index === 0) {
            const $el = $(this);
            const dataStyle = $el.attr('data-style');
        
            if (dataStyle && !$el.attr('data-style-applied')) {
              const currentStyle = $el.attr('style') || '';
              $el.attr('style', currentStyle + ';' + dataStyle);
              $el.attr('data-style-applied', 'true'); // Mark as processed
            }  
         }
          
       }); 
             
      // Exit early if all elements already have data-style-applied
       $banners1.each(function (index) {
         if (index === 0) {
           const $el = $(this);
            const dataStyle = $el.attr('data-style');
            if (dataStyle && !$el.attr('data-style-applied')) {
              const currentStyle = $el.attr('style') || '';
              $el.attr('style', currentStyle + ';' + dataStyle);
              $el.attr('data-style-applied', 'true'); // Mark as processed
            }  
           }
       }); 
            

        // Second images lazy load after first scroll
        var isSecondImagesLoaded = false;
        $(window).on('scroll', function() {
          if (!isSecondImagesLoaded) {
             // var $firstSection = $('.js-collection-section').first();
             //  $firstSection.find('.js-ProductItem__Image--alternate').each(function(){
             //    var $this = $(this),
             //        isInViewPort = $this.isInViewport();
    
             //    if (isInViewPort) {
             //      var $img = $this.find('img'),
             //          newSrc = $img.attr('data-src-2');
                  
             //        $img.attr('src', newSrc);
             //        console.log('Image loaded lazy')
             //    }
             //  }) 
             //  isSecondImagesLoaded = true;
          } 
        })

        $('.shopify-section--collection').first().addClass('found');


        
        $(window).one('scroll', function() {
          // Lazy load carousel images (first collection)
          // var $initialCollectionSection = $('.shopify-section--collection').first();
          // $initialCollectionSection.find('.js-ProductItem__Image--alternate').each(function(){
          //   var $img = $(this).find('img'),
          //       newSrc = $img.attr('data-src-2');
            
          //     $img.attr('src', newSrc)
          // })
        })
		
        $(window).on('scroll', function() {
            
            // Lazy load collections
			if ($('.is-loading-section').isInViewport()) {
          var $this = $('.is-loading-section');
          console.log('reached the bottom');
          
          $this.find('.js-collection-section').removeClass('is-loading');
          $this.removeClass('is-loading-section is-hidden-section');
          
          // Load banners
          var $banner = $this.find('.js-PageHeader--Image'),
              $bannerInner = $this.find('.js-PageHeader--withBackground');
              bannerImage = $banner.attr('data-style'),
              bannerInnerImage = $bannerInner.attr('data-style');

              $banner.attr('style', bannerImage);
              $bannerInner.attr('style',bannerInnerImage);

          // Load product images
          $this.find('.js-ProductItem__Image--initial').each(function(){
            var $img = $(this).find('img'),
                newSrc = $img.attr('data-src-2');
            $img.attr('src', newSrc);
          });

          // Add loading state for next section
          setTimeout(function() {
            var $next = $this.next('.shopify-section');
            $next.addClass('is-loading-section');
            //$next.removeClass('is-hidden-section');
            $next.find('.js-collection-section').removeClass('is-loading');
          }, 1000)
			}

              
            // $this.find('.ProductItem__Image--initial').each(function(){
            // 	var $img = $(this).find('img'),
        //                     newSrc = $img.attr('data-src-2');
            // 	$img.attr('src', newSrc)
            // })

            

            // Iterate image banners
            // const $elements = $('.js-PageHeader--Image');

            // // Exit early if all elements already have data-style-applied
            // if ($elements.length !== $elements.filter('[data-style-applied="true"]').length) {
            //    $elements.each(function () {
            //     const $el = $(this);
            //     const dataStyle = $el.attr('data-style');
            
            //     if (dataStyle && !$el.attr('data-style-applied')) {
            //       const currentStyle = $el.attr('style') || '';
            //       $el.attr('style', currentStyle + ';' + dataStyle);
            //       $el.attr('data-style-applied', 'true'); // Mark as processed
            //     }
            //   }); 
            //  }

            // Iterate image banners
            // const $banners = $('.js-PageHeader--withBackground');

            // // Exit early if all elements already have data-style-applied
            // if ($banners.length !== $banners.filter('[data-style-applied="true"]').length) {
            //    $banners.each(function () {
            //     const $el = $(this);
            //     const dataStyle = $el.attr('data-style');
            //     console.log('found');
            //     if (dataStyle && !$el.attr('data-style-applied')) {
            //       const currentStyle = $el.attr('style') || '';
            //       $el.attr('style', currentStyle + ';' + dataStyle);
            //       $el.attr('data-style-applied', 'true'); // Mark as processed
            //     }
            //   }); 
            //  }

            // Iterate video posters
            // if (!isVideosLoaded) {
            //   $('video').each(function() {
            //     const $video = $(this);
                
            //     // Skip if poster already applied
            //     if ($video.attr('data-poster-applied') === 'true') {
            //       return;
            //     }
              
            //     const dataPoster = $video.attr('data-poster');
              
            //     if (dataPoster) {
            //       $video.attr('poster', dataPoster);
            //       $video.attr('data-poster-applied', 'true');
            //     }

            //     isVideosLoaded = true;
            //   });
            // }
            
		});
	}

    function initCollectionSwitchSlide() {
      $('.ProductItem__Wrapper').on('touchend', '.flickity-prev-next-button', function(e){
        e.preventDefault();

        var $parent = $(this).parents('.ProductItem__Wrapper');
        $parent.find('.ProductItem__Image').each(function(){
          var $image = $(this).find('img'),
              newSrc = $image.attr('data-src-2');

          $image.attr('src', newSrc);
        })
      })
    }

    function setVideoEvents() {
      $('.Slideshow__VideoContainer').on('click', function(e) {
        var $this = $(this),
            $videoEl = $this.find('video'),
            $video = $videoEl.get(0),
            isVideoPaused = $video.paused,
            windowWidth = $(window).width();

        if (isVideoPaused && !$videoEl.hasClass('is-active') && windowWidth < 1000) {
          e.preventDefault();
          $videoEl.get(0).play();
          $videoEl.addClass('is-active');
        }
      })
      
      $('.ProductItem__ImageWrapper').on('click', function(e){
        var $this = $(this),
            isVideoItem = $this.find('.ProductItem__VideoWrapper').length > 0 ? true : false;

        if (isVideoItem) {
          var $videoEl = $this.find('video')
              $video = $videoEl.get(0),
              isVideoPaused = $video.paused;

          if (!isVideoPaused && !$videoEl.hasClass('is-active')) {
            e.preventDefault();
            $videoEl.addClass('is-active');
          } 
        }
      });
    }

    function initPDPEvents() {
      var windowWidth = $(window).width();

      if (windowWidth < 1000) {
        $('.TabNavButton[data-target="reviews"]').on('click', function(){
          $('html, body').animate({
              scrollTop: $("#reviews").offset().top
          }, 2000);
        }) 
      }
    }
	
	$('document').ready(function () {
		// initLazyCollectionImages();
		// initCollectionCarousels();
		initLazyCollectionProducts();
		initLazyScrollProducts();
    initCollectionSwitchSlide();
    initPDPEvents();
    setVideoEvents();
	})
}
